import AuthService from './authService';

export default function useAuth(axiosIns, authOverrideConfig) {
  const auth = new AuthService(axiosIns, authOverrideConfig);

  return {
    auth,
  };
}
